/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingDescriptionsTrendResult extends models.BillingAggregationTrendResult {
    getFixupPrototypeFunction() { return BillingDescriptionsTrendResult.fixupPrototype; }

    static newInstance(model: Partial<BillingDescriptionsTrendResult>): BillingDescriptionsTrendResult {
        let obj = Object.assign(new BillingDescriptionsTrendResult(), model);
        BillingDescriptionsTrendResult.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingDescriptionsTrendResult>): BillingDescriptionsTrendResult {
        if (!model) return null;
        return BillingDescriptionsTrendResult.newInstance(<BillingDescriptionsTrendResult> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingDescriptionsTrendResult) {
        if (!obj) return;

        models.BillingDescriptionsTrendResult.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingDescriptionsTrendResult): boolean {
        if (models.BillingAggregationTrendResult.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingDescriptionsTrendResult.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    descriptions: Array<string>;

}
